import type {
  TeacherCohortProgressMatrixAssignment,
  TeacherCohortProgressMatrixCell,
} from "../../auth/api-client";
import {
  ASSIGNMENT_PROGRESS_LABELS,
  type AssignmentProgressStatus,
} from "../../student/assignmentProgressStatus";

export function formatQuizScoreLabel(correct: number, total: number, attempts: number): string {
  const tries = attempts === 1 ? "1 try" : `${attempts} tries`;
  return `score ${correct}/${total} - ${tries}`;
}

export function matrixCellState(cell: TeacherCohortProgressMatrixCell | undefined): AssignmentProgressStatus {
  if (!cell) return "not_started";
  return cell.progressStatus;
}

export type MatrixCellDisplay = {
  primary: string;
  title: string;
};

export function formatMatrixCellDisplay(
  assignment: TeacherCohortProgressMatrixAssignment,
  cell: TeacherCohortProgressMatrixCell | undefined,
  studentEmail: string
): MatrixCellDisplay {
  const state = matrixCellState(cell);
  const statusLabel = ASSIGNMENT_PROGRESS_LABELS[state];

  if (assignment.itemKind === "quiz") {
    const attempts = cell?.quizAttemptCount ?? 0;
    const correct = cell?.quizScoreCorrect;
    const total = cell?.quizScoreTotal;
    if (attempts > 0 && correct != null && total != null) {
      const primary = formatQuizScoreLabel(correct, total, attempts);
      return { primary, title: `${studentEmail} · ${assignment.lessonTitle} · ${primary}` };
    }
    return {
      primary: statusLabel,
      title: `${studentEmail} · ${assignment.lessonTitle} · ${statusLabel}`,
    };
  }

  const primary = statusLabel;
  const title = `${studentEmail} · ${assignment.lessonTitle} · ${statusLabel}`;
  return { primary, title };
}

export function formatMatrixCellExportValue(
  assignment: TeacherCohortProgressMatrixAssignment,
  cell: TeacherCohortProgressMatrixCell | undefined
): string {
  return formatMatrixCellDisplay(assignment, cell, "").primary;
}
